<template>
  <!-- <div>
    <div class="el-loading-mask" style="background-color: rgba(0, 0, 0, 0.8);">
      <div class="el-loading-spinner">
        <i class="el-icon-loading"></i>
        <p class="el-loading-text">拼命加载中</p>
      </div>
    </div>
  </div> -->
  <div id="app">
    <div v-show="isLoading" class="el-loading-mask">
      <div class="el-loading-spinner">
        <svg class="circular" viewBox="25 25 50 50">
          <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
        </svg>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'app',
  created () {
    this.$store.dispatch('GetPower', '')
  },
  computed: {
    isLoading () {
      return this.$store.state.isLoading
    }
  },
  mounted(){
    document.onkeypress = (e) => {
            // if(e.key === 'Backspace'){
            //     e.preventDefault()
            //     e.stopPropagation()
            // }
            // return true
            var ev = e || window.event //获取event对象
            var obj = ev.target || ev.srcElement //获取事件源
            var t = obj.type || obj.getAttribute("type") //获取事件源类型
            //获取作为判断条件的事件类型
            var vReadOnly = obj.getAttribute("readonly")
            //处理null值情况
            vReadOnly = vReadOnly == "" ? false : vReadOnly
            //当敲Backspace键时，事件源类型为密码或单行、多行文本的，
            //并且readonly属性为true或enabled属性为false的，则退格键失效
            var flag1 = e.key === 'Backspace' && (t == "password" || t == "text" || t == "textarea") && vReadOnly == "readonly" ? true : false
            //当敲Backspace键时，事件源类型非密码或单行、多行文本的，则退格键失效
            var flag2 = e.key === 'Backspace' && t != "password" && t != "text" && t != "textarea" ? true : false

            //判断
            if (flag2) {
                return false
            }
            if (flag1) {
                return false
            }
        }
        //禁止后退键  作用于IE、Chrome
        document.onkeydown = (e) => {
            // if(e.key === 'Backspace'){
            //     e.preventDefault()
            //     e.stopPropagation()
            // }
            // return true
            var ev = e || window.event //获取event对象
            var obj = ev.target || ev.srcElement //获取事件源
            var t = obj.type || obj.getAttribute("type") //获取事件源类型
            //获取作为判断条件的事件类型
            var vReadOnly = obj.getAttribute("readonly")
            //处理null值情况
            vReadOnly = vReadOnly == "" ? false : vReadOnly
            //当敲Backspace键时，事件源类型为密码或单行、多行文本的，
            //并且readonly属性为true或enabled属性为false的，则退格键失效
            var flag1 = e.key === 'Backspace' && (t == 'number' || t == "password" || t == "text" || t == "textarea") && vReadOnly == "readonly" ? true : false
            //当敲Backspace键时，事件源类型非密码或单行、多行文本的，则退格键失效
            var flag2 = e.key === 'Backspace' && t != "password" && t != "text" && t != "textarea" && t != "number" ? true : false
            //判断
            if (flag2) {
                return false
            }
            if (flag1) {
                return false
            }
        }
  }
}
</script>

<style lang="less">
body, h1, h2, h3, h4, h5, h6, hr, p, blockquote, dl, dt, dd, ul, ol, li, pre, form, fieldset, legend, button, input, textarea, th, td { margin:0; padding:0; }
body, button, input, select, textarea { font:12px/1.5tahoma, arial, \5b8b\4f53; }
h1, h2, h3, h4, h5, h6{ font-size:100%; }
address, cite, dfn, em, var { font-style:normal; }
code, kbd, pre, samp { font-family:couriernew, courier, monospace; }
small{ font-size:12px; }
ul, ol { list-style:none; }
a { text-decoration:none !important; }
a:hover { text-decoration:underline; }
sup { vertical-align:text-top; }
sub{ vertical-align:text-bottom; }
legend { color:#000; }
fieldset, img { border:0; }
button, input, select, textarea { font-size:100%; }
table { border-collapse:collapse; border-spacing:0; }
.el-date-table td.in-range div, .el-date-table td.in-range div:hover, .el-date-table.is-week-mode .el-date-table__row.current div, .el-date-table.is-week-mode .el-date-table__row:hover div {
    background-color: #DCDFE6 !important;
}
#app {
  font-size: 12px;
  height: 100%;
  #tab {
    padding: 10px;
    height: 100%;
    box-sizing: border-box;
  }
  .el-card__header {
    font-size: 12px;
  }
  .el-table thead,
  .el-table .cell:not(.highlight) {
    color: #000 !important;
  }
  .el-select-dropdown__item {
    color: #303133;
  }

  .pagination {
    zoom: 1;
    background: #f1f1f1;
  }
}
html, body {
  height: 100%;
  box-sizing: border-box;
}
.el-dialog {
  margin: 0 auto !important;
  top: 50%;
  transform: translate(0, -50%);
}
.el-dialog-common {
  .el-dialog__header {
    padding: 15px 15px 0;
  }
  .el-dialog__body {
    padding: 10px 15px;
  }
  .el-dialog__footer {
    padding: 0 15px 10px;
  }
}
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  margin-right:2px;
}

::-webkit-scrollbar-button { /* 滚动条两端的按钮 */
    width:10px;
    background-color: rgb(239,238,240);
}
::-webkit-scrollbar:horizontal {
    height:10px;
    margin-bottom:2px
}
::-webkit-scrollbar-track {  /* 外层轨道 */
    border-radius: 0px;
}
::-webkit-scrollbar-track-piece {  /*内层轨道，滚动条中间部分 */
    background-color: rgb(239,238,240);
    border-radius: 0px;
}
::-webkit-scrollbar-thumb {  /* 滑块 */
    width:10px;
    border-radius: 5px;
    background: #CBCBCB;
}
::-webkit-scrollbar-corner { /* 边角 */
    width: 10px;
    background-color: rgb(239,238,240);
}
::-webkit-scrollbar-thumb:hover { /* 鼠标移入滑块 */
    background: #909090;
}
//滚动条小方块
// ::-webkit-scrollbar-thumb {
//   border-radius: 10px;
//   background: rgba(144, 147, 153, 0.3);
// }
// ::-webkit-scrollbar-thumb:hover {
//   background: rgba(144, 147, 153, 1);
// }
// //滚动条轨道
// ::-webkit-scrollbar-track {
//   border-radius: 10px;
//   height: 100px;
//   background: #fff;
// }
/**
  改变边框颜色
*/
.el-table--border, .el-table--group {
  border: 1px solid #ccc !important;
}
/**
  改变表格内竖线颜色
*/
.el-table--border  td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed {
  border-right: 1px solid #ccc !important;
}
/**
  改变表格内行线颜色
*/
.el-table  td, .el-table th.is-leaf  {
  border-bottom: 1px solid #ccc !important;
}

.el-table thead tr th{
  border-color: #ccc;
}

/**
  改变边框颜色
*/
.elx-table {
  border: 1px solid #ccc !important;
}
/**
  改变表格内竖线颜色
*/
.elx-table  td, .elx-table th, .elx-table__body-wrapper .elx-table.is-scrolling-left~.elx-table__fixed {
  border-right: 1px solid #ccc !important;
}
/**
  改变表格内行线颜色
*/
.elx-table  td, .elx-table th.is-leaf  {
  border-bottom: 1px solid #ccc !important;
}

.elx-table thead tr th{
  border-color: #ccc;
}
.elx-table.border--full .elx-body--column, .elx-table.border--full .elx-footer--column, .elx-table.border--full .elx-header--column {
  background: none;
}
.product-dialog {
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding: 0;
  }
}
/*下拉框item选项的hover样式*/
.el-select-dropdown__item.hover, .el-select-dropdown__item:hover {
  color: rgb(140, 197, 255);
  font-weight: 700;
}
</style>
